import React from "react";
import Switch from "react-switch";
import { dashboardColors, theme } from "../../themes/Theme";

const TwoLabelSwitch = ({
	label1,
	label2,
	value,
	onChangeSwitch,
	l1style,
	l2style,
	customClass,
	containerClass,
	className,
	isDisabled,
	offColor,
	onColor,
	offHandleColor,
	onHandleColor,
	activeBoxShadow,
	handleDiameter,
	width = 32
}) => {
	return (
		<>
			<label
				htmlFor="small-radius-switch"
				className={`d-inline-flex align-items-center ${containerClass ? containerClass : ""
					}`}
			>
				<span l1style={l1style} className="mr-2 span">
					{label1}
				</span>
				<Switch
					className="react-switch"
					height={18}
					width={width}
					disabled={isDisabled}
					handleDiameter={handleDiameter || 14}
					activeBoxShadow={activeBoxShadow || "0 0 2px 3px #ada5abff"}
					offColor={offColor || "#E9ECEF"}
					onColor={onColor || "#E9ECEF"}
					offHandleColor={offHandleColor || dashboardColors[theme].primary}
					onHandleColor={onHandleColor || dashboardColors[theme].primary}
					uncheckedIcon={false}
					checkedIcon={false}
					onChange={(e) => {
						if (!e) {
							onChangeSwitch(false);
						} else if (e) {
							onChangeSwitch(true);
						}
					}}
					checked={!value}
					value={!value}
				/>

				<span
					style={l2style}
					className={`${className == `custom-paid2` ? `custom-paid-ml` : `ml-2`
						} span`}
				>
					{label2}
				</span>
			</label>
			<style>{`
				.custom-paid-ml {
					padding-inline: 8px;
				}
			`}</style>
		</>
	);
};

export default TwoLabelSwitch;
